export function setCaminos(state, caminos_correos) {
    state.caminos_correos = caminos_correos;
}

export function setCorreosAccessToken(state, token) {
    state.correos_access_token = token;
}
